export default "__VITE_PUBLIC_ASSET__007f8186__"